import {
  CODE_ADMIN,
  CODE_3_FILTER_CONFIGURATION,
  CODE_4_FILTER_CONFIGURATION,
} from '@maximizer/ai/data-access';
import { ConfigurationSetting } from '@maximizer/core/shared/domain';

export const CONFIGURATION_FILTERS_ADMIN: ConfigurationSetting = {
  id: '1234abcd',
  code1: '',
  code2: CODE_ADMIN,
  code3: CODE_3_FILTER_CONFIGURATION,
  code4: CODE_4_FILTER_CONFIGURATION,
  textValue:
    '{"dataProcessingFeatures":{"anonymized":true,"useGlobalServers":false,"useWebData":false}}',
  intValue: 0,
};

export const CONFIGURATION_FILTERS_USER: ConfigurationSetting = {
  id: 'abcd1234',
  code1: '',
  code2: 'MEGAN',
  code3: CODE_3_FILTER_CONFIGURATION,
  code4: CODE_4_FILTER_CONFIGURATION,
  textValue:
    '{"wasFirstTimeOpenedPrivacySecurityCenter":true,"dataProcessingFeatures":{"anonymized":true,"useGlobalServers":false,"useWebData":false},"dataScope":{"all":true,"householdDetails":true,"accountDetails":true,"notes":true,"emails":true,"documents":true,"calls":true,"allInteractions":true,"dataFiltering":{"dueDate":"$LASTTWELVEMONTHS"}},"recentUserPrompts":["Prepare for Meeting","Another question","What client details should I confirm for this year\'s KYC review?","Hello","can you tell me what upcomming appointments I have"]}',
  intValue: 0,
};
